import {
  Component,
  inject,
  TemplateRef,
  ViewChild,
  effect,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import {
  DrawerComponent,
  DrawerItem,
  DrawerItemExpandedFn,
  DrawerSelectEvent,
  KENDO_DRAWER,
} from "@progress/kendo-angular-layout";
import { ContentComponent } from "../content/content.component";
import { items } from "../items";
import { EmployeeEditService } from "../employee-edit.service";
import { HostListener } from "@angular/core";
import { MenuService } from "../../services/menu.services";

@Component({
  selector: "app-mode-lecture",
  imports: [ReactiveFormsModule, KENDO_BUTTONS, KENDO_DRAWER, ContentComponent],
  providers: [EmployeeEditService],
  templateUrl: "./mode-lecture.component.html",
  styleUrls: ["./mode-lecture.component.css"],
})
export class ModeLectureComponent {
  readonly menuService = inject(MenuService);

  constructor() {
    this.menuService.ensureSelectedMenuItem();

    if (this.menuService.expandedDrawerIds().length === 0) {
      this.menuService.resetExpandedDrawerIds();
    }

    effect(() => {
      this.menuService.drawerToggleRequest();

      if (this.drawer) {
        this.drawer.toggle();
      }
    });
  }
  //--------------------------------------------------------------------------------------------------------------------

  swSauver = false;

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (!this.swSauver) {
      $event.preventDefault();
      $event.returnValue = "";
    }
  }

  @ViewChild("notificationTemplate", { read: TemplateRef })
  public notificationTemplate!: TemplateRef<unknown>;

  @ViewChild("drawer")
  public drawer?: DrawerComponent;

  public toggleDrawer(): void {
    this.drawer?.toggle();
  }

  public items: DrawerItem[] = items;

  public isItemExpanded: DrawerItemExpandedFn = (item): boolean => {
    if (!this.menuService.expandable()) {
      return false;
    }

    return this.menuService.expandedDrawerIds().includes(Number(item.id));
  };

  public onSelect(ev: DrawerSelectEvent): void {
    this.menuService.selectMenuItem(ev.item.id);

    if (!this.menuService.expandable()) {
      return;
    }

    this.menuService.toggleExpandedDrawerId(Number(ev.item.id));
  }
}
